export type FeatureFlagType = {
  PORTAL_SEND_SMS?: boolean;
  PORTAL_PAYMENT_METHODS_TAB_IN_SETTINGS?: boolean;
  DISABLED_UNLOCK_WHEN_CHECKED_IN?: boolean;
  MEMBER_APP_CHECK_IN?: boolean;
  NEW_MEMBERS_APPOINTMENTS?: boolean;
  NEW_MEMBERS_APP_CLASSES?: boolean;
  PORTAL_XERO?: boolean;
};

const globalFeatureFlagOverride: FeatureFlagType = {};

export const featureFlagOverrideMap = {
  portal: globalFeatureFlagOverride,
  memberApp: globalFeatureFlagOverride,
  staffApp: globalFeatureFlagOverride,
} as const;
